export const getFileName = (name: string) => {
  return name
    .split(' ')
    .join('-')
    .replace(/[.,/#!$%^&*;:{}=_`~()]/g, '')
    .toLowerCase()
    .trim();
};
